import { render, staticRenderFns } from "./rateDia.vue?vue&type=template&id=cb72120c&scoped=true"
import script from "./rateDia.vue?vue&type=script&lang=js"
export * from "./rateDia.vue?vue&type=script&lang=js"
import style0 from "./rateDia.vue?vue&type=style&index=0&id=cb72120c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.96.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb72120c",
  null
  
)

export default component.exports